import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { HeaderService } from '@core/services/header/header.service';
import { ROLE_CONSTANT } from '@sharedModule/constants/role-constant';
import { ClientNameService } from '@sharedModule/services/clientName/client-name.service';
import { map, Observable } from 'rxjs';

export const AuthGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  const headerService = inject(HeaderService);
  const clientNameService = inject(ClientNameService);

  if (inject(AuthenticationService).checkLogin()) {
     if (clientNameService.clientName()) {
    return true;
  }else{

    return authenticationService.getUserPermissions().pipe(
      map(res => {
        
        headerService.userName.set({
          email: res.data.email!,
          role: res.data.role?.type!,
          roleName:res.data.role.name,
          userId: res.data.userId!,
        });
        const clientName = res.data.clientId
                    ? res.data.clientId?.name
                    : res.data.name
                      ? ROLE_CONSTANT.WM.name
                      : ROLE_CONSTANT.SUPER_ADMIN.value;
          clientNameService.clientName.set(clientName);
          clientNameService.setCachedClientName(clientName)
          clientNameService.checkAndRedirect(router.routerState.snapshot.url)
        authenticationService.setUserPermission(res.data.permissions!);
        return true;
      })
    );
  }
  } else {
    return router.createUrlTree(['/auth/login']);
  }
};
